import React from 'react';
import { Link } from 'react-router-dom';
import { NavigationItems } from './NavigationItems';
import { AuthNavButtons } from './AuthNavButtons';
import { ThemeToggleButton } from './ThemeToggleButton';
import { LanguageSelector } from './LanguageSelector';
import SyncStatusIndicator from './SyncStatusIndicator';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-25 transition-opacity lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Slide-out menu */}
      <div
        className={`fixed inset-y-0 right-0 z-50 w-64 transform overflow-y-auto bg-white p-6 shadow-xl transition-transform duration-300 ease-in-out dark:bg-surface-900 lg:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close button */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="rounded-md p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-500 dark:hover:bg-surface-800"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Logo */}
        <div className="mb-8">
          <Link to="/landing" className="flex items-center gap-2" onClick={onClose}>
            <img src="/logo.svg" alt="FairBalance" className="h-7 w-7" />
            <span className="text-lg font-bold text-slate-800 dark:text-white">
              FairBalance
            </span>
          </Link>
        </div>

        {/* Navigation Items */}
        <div className="mb-8">
          <NavigationItems className="flex-col space-y-2" showLabels={true} />
        </div>

        {/* Auth */}
        <div className="border-t border-gray-200 pt-6 dark:border-gray-700">
          <AuthNavButtons />
        </div>

        {/* Settings */}
        <div className="space-y-4 border-t border-slate-200 pt-6 dark:border-surface-700/50">
          <div className="flex items-center justify-between">
            <span className="text-sm text-slate-500 dark:text-slate-400">Theme</span>
            <ThemeToggleButton />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-slate-500 dark:text-slate-400">Language</span>
            <LanguageSelector />
          </div>
        </div>

        {/* Sync Status */}
        <div className="absolute bottom-6 left-6 right-6">
          <SyncStatusIndicator />
        </div>
      </div>
    </>
  );
};
